import { Show, createEffect, createSignal } from "solid-js";
import { Form, Button, Spinner } from "solid-bootstrap";
import { fetchResource } from "../../../util/fetch";
import { Service } from "../../../service/device/setup";

export function DeviceForm(props) {
    const [myDevice, refetch] = fetchResource(() => Service.getDevice(props.device.uuid));
    const [isSubmitting, setIsSubmitting] = createSignal(false);
    const [isError, setIsError] = createSignal(false);
    createEffect(() => {
        if (!myDevice.loading) {
            props.setDevice(myDevice());
        }
    });
    const onSubmit = (ev) => {
        if (props.validate !== undefined && !props.validate()) {
            return;
        }
        ev.preventDefault();
        setIsSubmitting(true);
        setIsError(false);
        Service.getDevice(props.device.uuid).then(systemDevice => {
            props.readFormFields(systemDevice);
            Service.updateDevice(systemDevice).then(() => {
                refetch();
            }).catch(() => {
                setIsError(true);
            }).finally(() => {
                setIsSubmitting(false);
            });
        });
    };
    return <>
        <h1 class="mb-3">{props.title}</h1>
        <Show when={!myDevice.loading}>
            <Form onSubmit={onSubmit} class="d-flex flex-column gap-3">
                {props.children}
                <div class="d-flex flex-row gap-3">
                    <Button type="submit">{props.submitText}</Button>
                    <Show when={isSubmitting()}><Spinner animation="border" /></Show>
                    <Show when={!isSubmitting()}>
                        <i>Saved</i>
                    </Show>
                    <Show when={isError()}>
                        <i>Error</i>
                    </Show>
                </div>
            </Form>
        </Show>
        <Show when={myDevice.loading}>
            <Spinner animation="border"/>
        </Show>
    </>
}